import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Vendor } from 'app/core/model/vendor';
import { AuditDialogComponent } from 'app/shared/audit-dialog/audit-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, AuthService, GenesisUnitOfWork } from '../../core/core.module';
import { PurchaseOrderLineItem } from 'app/core/model/purchase-order-line-item';
import { VendorTerm } from 'app/core/model/vendor-term';
import { VendorPaymentMethod } from 'app/core/model/vendor-payment-method';

@Component({
    selector: 'app-vendor-detail',
    templateUrl: './vendor-detail.component.html',
    styleUrls: ['./vendor-detail.component.scss'],
    standalone: false
})
export class VendorDetailComponent implements OnInit {
    key: any;
    vendor: any;
    states: any;
    countries: any[] = ['US', 'OTHER'];
    purchaseOrderLineItems: PurchaseOrderLineItem[];
    vendorTerms: VendorTerm[];
    vendorPaymentMethods: VendorPaymentMethod[];

    readOnly = true;

    constructor(
        private uow: GenesisUnitOfWork,
        private auth: AuthService,
        private route: ActivatedRoute,
        protected location: Location,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private router: Router
    ) {}

    async ngOnInit() {
        this.readOnly = !this.auth.hasRole('Admin');
        this.states = this.uow.lookups.states;
        this.purchaseOrderLineItems = (await this.uow.purchaseOrderLineItems.whereActive('displayOrder, name')) as PurchaseOrderLineItem[];
        this.vendorTerms = await this.uow.vendorTerms.whereActive('displayOrder, name') as VendorTerm[];
        this.vendorPaymentMethods = await this.uow.vendorPaymentMethods.whereActive('displayOrder, name') as VendorPaymentMethod[];

        this.key = this.route.snapshot.params['id'];
        if (this.key === 'new') {
            this.vendor = this.uow.vendors.createEntity();
            this.vendor.state = 'MI';
            this.vendor.country = 'US';
        } else {
            this.vendor = await this.uow.vendors.byId(this.key) as Vendor;
        }
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    async save() {
        this.appInfo.pleaseWaitShow();

        this.vendor.quickBooksLastExport = null;
        await this.uow.commit();
        if (this.key === 'new') {
            this.router.navigate(['../' + this.vendor.id], { relativeTo: this.route, replaceUrl: true, state: { navigateOnSaveNew: true } });
        }
        this.key = this.vendor.id;
        this.appInfo.pleaseWaitHide();
    }

    cancel() {
        this.uow.rollback();
        this.close();
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }

    async auditLog() {
        const auditLogs = [];

        const vendorAudits = await this.uow.getHistory('Vendor', [this.vendor.id]);
        vendorAudits.forEach((audit) => {
            auditLogs.push(audit);
        });

        const modalRef = this.modalService.show(AuditDialogComponent, {
            class: 'modal-md',
            initialState: {
                auditLogs: auditLogs,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result) {
            }
            modalRef.hide();
        });
    }
}
